import { ILengthAlertBehavior } from "./ILengthAlertBehavior";

export interface ILengthAlertBehaviorSpecifiable {
  lengthAlertBehavior: ILengthAlertBehavior;
}

export function instanceOfILengthAlertBehaviorSpecifiable(instance: any): instance is ILengthAlertBehaviorSpecifiable {
  return instance
    && (instance.lengthAlertBehavior !== undefined);
}
